/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Origin of the quote that created this project
 * @export
 */
export const QuoteSource = {
    FromClientProject: 'FROM_CLIENT_PROJECT',
    DirectFromFreelanceToKnownClient: 'DIRECT_FROM_FREELANCE_TO_KNOWN_CLIENT',
    DirectFromFreelanceToUnknownClientWithAccount: 'DIRECT_FROM_FREELANCE_TO_UNKNOWN_CLIENT_WITH_ACCOUNT',
    DirectFromFreelanceToUnknownClientWithoutAccount: 'DIRECT_FROM_FREELANCE_TO_UNKNOWN_CLIENT_WITHOUT_ACCOUNT',
    ExistingContract: 'EXISTING_CONTRACT',
    ExpenseFromMission: 'EXPENSE_FROM_MISSION',
    MicroConsulting: 'MICRO_CONSULTING'
} as const;
export type QuoteSource = typeof QuoteSource[keyof typeof QuoteSource];


export function instanceOfQuoteSource(value: any): boolean {
    for (const key in QuoteSource) {
        if (Object.prototype.hasOwnProperty.call(QuoteSource, key)) {
            // @ts-ignore
            if (QuoteSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteSourceFromJSON(json: any): QuoteSource {
    return QuoteSourceFromJSONTyped(json, false);
}

export function QuoteSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteSource {
    return json as QuoteSource;
}

export function QuoteSourceToJSON(value?: QuoteSource | null): any {
    return value as any;
}

